import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react';
import NotFoundPage from "Components/notFoundPage";
import MkMessageList from "Components/MkMessaging/mkMessageList";
import NewMessage from "Components/MkMessaging/newMessage";
import MkExistentMessageView from "Components/MkMessaging/mkExistentMessageView";
import MkMessagingStore from "Stores/mkMessaging/mkMessagingStore";

const MkMessaging = (props) => {
    if (props.migrationNeeded) {
        return (
            <Navigate to={`${window.SmrLocation}/migration`} />
        )
    }

    return (
        <Routes>
            <Route
                path={`/mkMessageList`}
                element={<MkMessageList
                    location={window.location}
                    resetNavigateFromMessageDetails={MkMessagingStore.ResetNavigateFromMessageDetails.bind(MkMessagingStore)}
                />} />
            <Route
                path={`/newMessage`}
                element={<NewMessage
                    location={window.location}
                />} />
            <Route
                path={`/viewMessage`}
                element={<MkExistentMessageView
                    location={window.location}
                    showAlertAfterCancellation={(alert) => { MkMessagingStore.navigateFromMessageDetails = true; MkMessagingStore.alertAfterNavigation = alert }}
                />} />
            <Route
                path={'/'}
                element={<Navigate to={`./mkMessageList`} />} />
            <Route
                path={'*'}
                element={<NotFoundPage />} />
        </Routes>
    );
}

export default observer(MkMessaging);